import service from '@/utils/service';
import { Message } from 'element-ui';
// 测试 baseURL 是否生效
/**
 * 统一请求封装
 * @param {string} url - 请求地址（不带 baseURL）
 * @param {string} method - 请求方法 GET/POST/PUT/DELETE
 * @param {any} data - 请求数据（GET 时为 params，其他为 data）
 * @param {Object} options - 额外配置
 * @returns {Promise<any>}
 */
export function request(url, method = 'GET', data = null, options = {}) {
    console.log(service.defaults.baseURL); // 应该输出 '/api'

    const { successMsg, showLoading = true, headers, ...axiosConfig } = options;

    const config = {
        // ✅ 关键：不要传 url，而是传到 service 的 baseURL + url 自动拼接
        // ❌ url, // 删除这一行！
        method,
        headers: {
            ...headers,
            showLoading: showLoading,
        },
        ...(method.toUpperCase() === 'GET' ? { params: data } : { data }),
        ...axiosConfig,
    };

    // ✅ 正确：把 url 作为第一个参数，service 会自动拼接 baseURL
    return service(url, config).then((res) => {
        if (successMsg) {
            Message.success(successMsg);
        }
        return res;
    });
}

// 便捷方法
export const get = (url, params, options) => request(url, 'GET', params, options);
export const post = (url, data, options) => request(url, 'POST', data, options);

export default { get, post };
